import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { ServicesData } from "./services";

function resolveImage(img) {
  if (!img) return "";
  if (typeof img === "string") return img;
  if (typeof img === "object" && img.default) return img.default;
  return "";
}

/** Same shape as API rows: { id, name, description, price, image } */
export function getStaticCatalogServices() {
  return ServicesData.map((s) => ({
    id: `local-${s.id}`,
    name: s.name,
    description: s.description,
    price: s.price,
    image: resolveImage(s.image),
  }));
}

function normalizeApiList(raw) {
  const list = Array.isArray(raw) ? raw : [];
  return list.map((s) => ({
    id: s.id,
    name: s.name,
    description: s.description || "",
    price: s.priceDisplay,
    image: s.imageUrl || "",
  }));
}

/**
 * Services offered on the quote page (quote + carousel).
 * @param {string} [operatorSlug] - When set, loads GET /catalog-services?o=slug (operator catalog). Otherwise platform /quote catalog.
 */
export function useCatalogServices(operatorSlug = "") {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const slugKey = (operatorSlug || "").trim().toLowerCase();

  const refetch = useCallback(async () => {
    setLoading(true);
    try {
      const params = slugKey ? { params: { o: slugKey } } : {};
      const { data } = await axios.get("/catalog-services", params);
      const list = normalizeApiList(data.services);
      const fallback = slugKey ? [] : getStaticCatalogServices();
      setServices(list.length > 0 ? list : fallback);
    } catch {
      setServices(slugKey ? [] : getStaticCatalogServices());
    } finally {
      setLoading(false);
    }
  }, [slugKey]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { services, loading, refetch };
}
